"use client"

/**
 * Chatwoot website chat widget.
 * Loads only when NEXT_PUBLIC_CHATWOOT_WEBSITE_TOKEN is set.
 * Does NOT render on /admin/* routes (admin has its own UI, no widget needed).
 */

import { useEffect } from "react"
import { usePathname } from "next/navigation"

export function ChatwootWidget() {
  const pathname = usePathname()
  const token = process.env.NEXT_PUBLIC_CHATWOOT_WEBSITE_TOKEN
  const baseUrl = process.env.NEXT_PUBLIC_CHATWOOT_URL

  useEffect(() => {
    if (!token || !baseUrl) return
    if (pathname?.startsWith("/admin")) return   // hide on admin routes
    if (pathname?.startsWith("/lead")) return    // hide on legacy /lead path too
    if (typeof window === "undefined") return
    if ((window as any).chatwootSDK) return       // already loaded

    const s = document.createElement("script")
    s.src = `${baseUrl}/packs/js/sdk.js`
    s.async = true
    s.onload = () => {
      ;(window as any).chatwootSDK?.run({ websiteToken: token, baseUrl })
    }
    document.head.appendChild(s)
  }, [pathname, token, baseUrl])

  return null
}
